import { useFormik } from "formik";
import BoardTextInput from "../../../../components/inputs/dashboardTextInput";
import BoardButton from "../../../../components/buttons/boardButton";
import { useState } from "react";
import DateTimePicker from "react-datetime-picker";
import LinearCalendarIcon from "../../../../icons/linearCalendarIcon";
import i18n from "../../../../i18n";
import { mode, primaryColor } from "../../../../utils";

const EditOffer = ({ t }) => {
  const formik = useFormik({
    initialValues: {},
    onSubmit: (values) => {
      console.log(values);
    },
  });

  const handleCancel = () => {
    formik.resetForm();
  };

  const [startDateValue, onStartDateChange] = useState(new Date());
  const [endDateValue, onEndDateChange] = useState(new Date());

  const formatDate = (date) =>
    date.toLocaleDateString(i18n.language === "ar" ? "ar-EG" : "en-GB", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    });

  return (
    <form onSubmit={formik.handleSubmit} className="text-black dark:text-white">
      {/* اسم العرض */}
      <BoardTextInput formik={formik} label={t("offerName")} name="name" />

      {/* وصف مختصر */}
      <BoardTextInput
        formik={formik}
        label={t("briefDescription")}
        name="description"
      />

      {/* نسبة الخصم */}
      <BoardTextInput formik={formik} label={t("discountRate")} name="rate" />

      {/* التواريخ */}
      <section className="flex flex-wrap items-center gap-4 my-5 md:flex-nowrap">
        {/* تاريخ البداية */}
        <div className="p-4 rounded-xl bg-[#F3F4F6] dark:bg-[#1F2937] min-w-[200px]">
          <div className="flex items-center gap-2">
            <DateTimePicker
              format=" "
              disableClock
              onChange={onStartDateChange}
              value={startDateValue}
              calendarIcon={
                <LinearCalendarIcon stroke={mode === "dark" ? "white" : ""} />
              }
              clearIcon={null}
            />
            <span>{t("startDate")}</span>
          </div>
          <h3 className="text-end" style={{ color: primaryColor }}>
            {formatDate(startDateValue)}
          </h3>
        </div>

        {/* تاريخ النهاية */}
        <div className="p-4 rounded-xl bg-[#F3F4F6] dark:bg-[#1F2937] min-w-[200px]">
          <div className="flex items-center gap-2">
            <DateTimePicker
              format=" "
              disableClock
              onChange={onEndDateChange}
              value={endDateValue}
              calendarIcon={
                <LinearCalendarIcon stroke={mode === "dark" ? "white" : ""} />
              }
              clearIcon={null}
            />
            <span>{t("endDate")}</span>
          </div>
          <h3 className="text-end" style={{ color: primaryColor }}>
            {formatDate(endDateValue)}
          </h3>
        </div>
      </section>

      {/* الأزرار */}
      <div className="flex flex-wrap mx-auto items-center md:flex-nowrap max-w-[600px] gap-4">
        <BoardButton
          type="button"
          onClick={handleCancel}
          secondary
          bg
          className="w-full"
        >
          {t("cancel")}
        </BoardButton>
        <BoardButton type="submit" primary bg className="w-full">
          {t("edit")}
        </BoardButton>
      </div>
    </form>
  );
};

export default EditOffer;
